import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

function CreditPurchase() {
  const navigate = useNavigate();
  const { user, addCredits, refreshCredits } = useAuth(); // ✅ Added refreshCredits
  const [isProcessing, setIsProcessing] = useState(false);

  const creditPackages = [
    {
      id: 1,
      credits: 50,
      price: 99,
      popular: false,
      bonus: 0,
      description: "Perfect for casual users"
    },
    {
      id: 2,
      credits: 120,
      price: 199,
      popular: true,
      bonus: 20,
      description: "Most popular choice"
    },
    {
      id: 3,
      credits: 250,
      price: 399,
      popular: false,
      bonus: 50,
      description: "Best value for money"
    },
    {
      id: 4,
      credits: 500,
      price: 699,
      popular: false,
      bonus: 100,
      description: "For astrology enthusiasts"
    }
  ];

  // ✅ Enhanced purchase handler with database integration
  const handlePurchase = async (packageData) => {
    if (isProcessing) return;
    
    setIsProcessing(true);
    console.log('💳 Processing purchase:', packageData);

    try {
      const totalCredits = packageData.credits + packageData.bonus;
      const packageInfo = {
        packageId: packageData.id,
        baseCredits: packageData.credits,
        bonusCredits: packageData.bonus,
        price: packageData.price,
        description: packageData.description
      };

      // ✅ Add credits through database API
      const result = await addCredits(
        totalCredits, 
        `Credits purchased - ${packageData.description}`, 
        packageInfo
      );

      if (result && result.success) {
        // ✅ Refresh credits to ensure sync
        await refreshCredits();

        const successMessage = `🎉 Successfully purchased ${totalCredits} credits!\n\n` +
          `Previous Balance: ${result.previousCredits} credits\n` +
          `Credits Added: +${result.addedAmount} credits\n` +
          `New Balance: ${result.currentCredits} credits`;

        alert(successMessage);
        console.log('✅ Purchase successful:', result);
        navigate('/chat');
      } else {
        throw new Error(result?.error || 'Purchase failed');
      }
    } catch (error) {
      console.error('❌ Purchase error:', error);
      alert(`❌ Purchase failed: ${error.message || 'Please try again.'}`);
    } finally {
      setIsProcessing(false);
    }
  };

  const goBack = () => {
    navigate('/chat');
  };

  return (
    <div className="credit-purchase-container">
      {/* Mystical Background Elements */}
      <div className="bg-element bg-diamond">💎</div>
      <div className="bg-element bg-star">⭐</div>
      <div className="bg-element bg-crystal">🔮</div>

      {/* Back Button */}
      <div className="back-button-container">
        <button className="back-button" onClick={goBack}>
          <span>←</span>
          <span>Back</span>
        </button>
      </div>

      {/* Main Content */}
      <div className="credit-content">
        {/* Title Section */}
        <div className="credit-title-section">
          <h1 className="credit-main-title">💎 Get More Cosmic Credits</h1>
          <p className="credit-subtitle">
            Unlock unlimited cosmic wisdom with our credit packages.<br/>
            Each question costs 5 credits • First question: 10 credits
          </p>
          {/* ✅ Enhanced current balance display */}
          <div className="current-balance-display">
            <span className="balance-label">Your Current Balance:</span>
            <span className="balance-amount">💎 {user?.credits || 0} Credits</span>
            {user?.credits < 10 && <span className="low-credits-warning">⚠️ Low Credits</span>}
          </div>
        </div>

        {/* Additional Info 
        <div className="credit-usage-info">
          <h3 className="usage-title">
            <span>ℹ️</span>
            <span>Credit Usage</span>
          </h3>
          <div className="usage-grid">
            <div className="usage-item first-question">
              <strong>🔮 First Question:</strong><br/>
              Costs 10 credits
            </div>
            <div className="usage-item follow-up">
              <strong>💬 Follow-up Questions:</strong><br/>
              Cost 5 credits each
            </div>
            <div className="usage-item new-users">
              <strong>🎁 New Users:</strong><br/>
              Get 20 free credits
            </div>
          </div>
        </div>*/}

        {/* Credit Packages Grid */}
        <div className="credit-packages-grid">
          {creditPackages.map((pkg) => (
            <div 
              key={pkg.id} 
              className={`credit-package ${pkg.popular ? 'popular' : ''}`}
            >
              {/* Popular Badge */}
              {pkg.popular && (
                <div className="popular-badge">🌟 MOST POPULAR</div>
              )}

              <div className="package-content">
                {/* Credits Display */}
                <div className="package-credits">{pkg.credits}</div>
                <div className="credits-label">
                  <span>💎</span>
                  <span>Credits</span>
                </div>

                {/* Bonus Credits */}
                {pkg.bonus > 0 && (
                  <div className="bonus-credits">
                    🎁 +{pkg.bonus} Bonus Credits
                  </div>
                )}

                {/* Price */}
                <div className="package-price">₹{pkg.price}</div>

                {/* Description */}
                <div className="package-description">{pkg.description}</div>

                {/* Value Calculation */}
                <div className="package-value">
                  Total: {pkg.credits + pkg.bonus} credits • 
                  ₹{(pkg.price / (pkg.credits + pkg.bonus)).toFixed(1)} per credit
                </div>

                {/* Purchase Button */}
                <button
                  className={`purchase-btn ${pkg.popular ? 'popular-btn' : ''}`}
                  onClick={() => handlePurchase(pkg)}
                  disabled={isProcessing}
                >
                  {isProcessing ? '⏳ Processing...' : '🛒 Purchase Now'}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CreditPurchase;
